// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"64":"91428c7e09dcaeefa584","495":"26fb7e409d8a14fc8c4d"}[chunkId] + ".chunk.js";
};